(function () {

  'use strict';

  angular.module('PrintixMainMenu', [])

    .constant('PrintixMenuConstantsURLS', {
      MENU_MAIN_ITEMS: 'assets/jsonFiles/menu/mainMenuItems.json'
    })

    .constant('PrintixMainMenuSelectors', {
      MAIN_MENU_CLASS_SELECTOR: 'main-menu-parent',
      LANGUAGE_LIST_ITEM_CLASS_SELECTOR: 'language-menu-parent'
    })

    .constant('RequiredMenuItemProperties', [
      'show', 'icon', 'testKey', 'isSeparator', 'key', 'key.content', 'key.allCapital',
      'value', 'value.expression', 'value.content', 'value.allCapital', 'clickFunction', 'goToUrl'
    ])

    .controller('MainMenuController', function (
      $rootScope, $scope, $filter, $location, Utils, $http, PrintixMenuConstantsURLS, RequiredMenuItemProperties,
      $parse, PrintixMainMenuSelectors) {

      $scope.mainMenuItems = [];
      $scope.mainMenuClassSelector = PrintixMainMenuSelectors.MAIN_MENU_CLASS_SELECTOR;
      $scope.languageListItemClassSelector = PrintixMainMenuSelectors.LANGUAGE_LIST_ITEM_CLASS_SELECTOR;
      $scope.me = null;

      $scope.getCurrentUrl = function () {
        return $location.path();
      };

      $scope.menuItemClicked = function (event, menuItem) {
        if (menuItem) {
          if (menuItem.isLanguageMenuToggle) {
            event.stopPropagation();
            event.preventDefault();
            angular.element('.' + $scope.languageListItemClassSelector).addClass('open');
            Utils.adjustMenuDropDowns();
          } else {
            if (menuItem.clickFunction && !angular.isFunction(menuItem.clickFunction)) {
              $parse(menuItem.clickFunction)($rootScope)();
            }
          }
        } else {
          throw new Error('$scope.menuItemClicked: menuItem is missing');
        }
      };

      // Called from "app/shared-components/navigation-bar/navigation-bar.html"
      $rootScope.refreshMenuItemsExpressionResult = function () {
        angular.forEach($scope.mainMenuItems, function (menuItem) {
          refreshMenuItemExpressionResult(menuItem);
        });
      };

      $scope.$watch(function () {
        return $location.path();
      }, function () {
        checkPath();
      });

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
          if (!$scope.mainMenuItems || !$scope.mainMenuItems.length) {
            getMenuItems();
          }
        }
      });

      function checkPath() {
        const path = $location.path();
        if (path.indexOf('/sites') > -1) {
          $scope.path = '#/sites';
        } else {
          $scope.path = '#' + path;
        }
      }

      function getMenuItems() {
        $http.get(PrintixMenuConstantsURLS.MENU_MAIN_ITEMS, { cache: true })
          .then(addMenuItemToMainMenuItemsSuccessCallback)
          .catch(function () {
          });
      }

      function addMenuItemToMainMenuItemsSuccessCallback(response) {
        $scope.mainMenuItems = [];
        if ($scope.me) {
          angular.forEach(response.data, function (menuItem) {
            refreshMenuItemExpressionResult(menuItem);
            if ($scope.me.permissions.TENANT_ADMIN || menuItem.link !== '#/subscription') {
              $scope.mainMenuItems.add(menuItem);
            }
          });
        }
      }

      function refreshMenuItemExpressionResult(menuItem) {
        if (menuItem) {
          if (typeof menuItem.show !== 'boolean') {
            menuItem.showResult = Utils.evalJs(menuItem.show);
          } else {
            menuItem.showResult = angular.copy(menuItem.show);
          }
          if (menuItem.alternativeActiveFunction) {
            menuItem.alternativeActive = Utils.evalJs(menuItem.alternativeActiveFunction);
          }
          if (menuItem.value.expression) {
            menuItem.value.expressionResult = Utils.evalJs(menuItem.value.expression);
          } else {
            menuItem.value.expressionResult = angular.copy(menuItem.value.content);
          }
        } else {
          throw new Error('refreshMenuItemExpressionResult: menuItem is missing');
        }
      };

    })

    .directive('hideMenus', function () {
      return {
        link: function ($scope, element, attrs) {
          element.on('click', function (event) {
            angular.element('.' + $scope.languageListItemClassSelector).removeClass('open');
            angular.element('.' + $scope.mainMenuClassSelector).removeClass('open');
            event.stopPropagation();
          });
          angular.element('.' + $scope.mainMenuClassSelector).on('hide.bs.dropdown', function () {
            angular.element('.' + $scope.languageListItemClassSelector).removeClass('open');
          });
        }
      };
    });

})();
